export const FF_DASHBOARD_NOTIFICATION_SETTINGS = 'dashboard-notification-settings';
export const FF_DASHBOARD_CUSTOMER_MANAGEMENT = 'dashboard-customer-management';
export const FF_DASHBOARD_CUSTOMER_BALANCES = 'dashboard-customer-balances';
export const FF_DASHBOARD_INTEGRATOR_USD_BALANCE = 'dashboard-integrator-usd-balance';
export const FF_DASHBOARD_ALLOW_VA_CREATION_FOR_INDIVIDUALS =
  'dashboard-allow-va-creation-for-individuals';
export const FF_DASHBOARD_USDC_USDT_WALLET_DETAILS = 'dashboard-usdc-usdt-wallet-details';
export const FF_DASHBOARD_FX_MARKUP = 'dashboard-fx-markup';
export const FF_DASHBOARD_INTEGRATOR_EARNINGS_WITHDRAWAL =
  'dashboard-integrator-earnings-withdrawal';
